import { apis } from '../apiBase/apiBase';
export const taskApis = apis.injectEndpoints({
    endpoints: (builder) => ({
        deleteTask: builder.mutation({
            query: (params) => ({
                url: `tasks/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        insertTask: builder.mutation({
            query: (params) => ({
                url: `tasks/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        getTaskKinds: builder.query({
            query: (params) => ({
                url: `task-kinds`,
                params: params,
            }),
        }),
        insertTaskKind: builder.mutation({
            query: (params) => ({
                url: `task-kinds/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        updateTaskKind: builder.mutation({
            query: (params) => ({
                url: `task-kinds/update`,
                method: `POST`,
                body: params,
            }),
        }),
        reorderTaskKind: builder.mutation({
            query: (params) => ({
                url: `task-kinds/reorder`,
                method: `POST`,
                body: params,
            }),
        }),
        getTaskKind: builder.query({
            query: (params) => {
                return {
                    url: `task-kinds/${params.taskKindId}`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        deleteTaskKind: builder.mutation({
            query: (params) => ({
                url: `task-kinds/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        reorderTaskCategory: builder.mutation({
            query: (params) => ({
                url: `task-categories/reorder`,
                method: `POST`,
                body: params,
            }),
        }),
        insertTaskState: builder.mutation({
            query: (params) => ({
                url: `task-states/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        getTaskStates: builder.query({
            query: (params) => ({
                url: `task-states`,
                params: params,
            }),
        }),
        getTaskState: builder.query({
            query: (params) => {
                return {
                    url: `task-states/${params.taskStateId}`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        reorderTaskState: builder.mutation({
            query: (params) => ({
                url: `task-states/reorder`,
                method: `POST`,
                body: params,
            }),
        }),
        updateTaskState: builder.mutation({
            query: (params) => ({
                url: `task-states/update`,
                method: `POST`,
                body: params,
            }),
        }),
        deleteTaskState: builder.mutation({
            query: (params) => ({
                url: `task-states/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getTaskCategories: builder.query({
            query: (params) => {
                return {
                    url: `task-categories`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getTaskCategory: builder.query({
            query: (params) => {
                return {
                    url: `task-categories/${params.taskCategoryId}`,
                    method: 'GET',
                };
            },
        }),
        deleteTaskCategory: builder.mutation({
            query: (params) => ({
                url: `task-categories/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        updateTaskCategory: builder.mutation({
            query: (params) => ({
                url: `task-categories/update`,
                method: `POST`,
                body: params,
            }),
        }),
        insertTaskCategory: builder.mutation({
            query: (params) => ({
                url: `task-categories/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        getTask: builder.query({
            query: (params) => {
                return {
                    url: `tasks/${params.taskId}`,
                    method: 'GET',
                };
            },
        }),
        getTaskCommentsAndHistories: builder.query({
            query: (params) => {
                return {
                    url: 'task-comments-and-histories',
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getTasks: builder.query({
            query: (params) => {
                return {
                    url: `tasks`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        insertTaskComment: builder.mutation({
            query: (params) => ({
                url: `task-comments/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        updateTask: builder.mutation({
            query: (params) => ({
                url: `tasks/update`,
                method: `POST`,
                body: params,
            }),
        }),
        getTaskWorks: builder.query({
            query: (params) => {
                return {
                    url: `task-works`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        insertTaskWork: builder.mutation({
            query: (params) => ({
                url: `task-works/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        updateTaskWork: builder.mutation({
            query: (params) => ({
                url: `task-works/update`,
                method: `POST`,
                body: params,
            }),
        }),
        deleteTaskWork: builder.mutation({
            query: (params) => ({
                url: `task-works/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getTaskWork: builder.query({
            query: (params) => {
                return {
                    url: `task-works/${params.taskWorkId}`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        deleteTaskComment: builder.mutation({
            query: (params) => ({
                url: `task-comments/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        updateTaskComment: builder.mutation({
            query: (params) => ({
                url: `task-comments/update`,
                method: `POST`,
                body: params,
            }),
        }),
        updateTaskDuration: builder.mutation({
            query: (params) => ({
                url: `tasks/update-task-duration`,
                method: `POST`,
                body: params,
            }),
        }),
        deleteTaskHistory: builder.mutation({
            query: (params) => ({
                url: `task-histories/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getTaskComment: builder.query({
            query: (params) => {
                return {
                    url: `task-comments/${params.taskCommentId}`,
                    method: 'GET',
                };
            },
        }),
        getMyTasks: builder.query({
            query: (params) => {
                return {
                    url: `tasks/my-tasks`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getTaskFiles: builder.query({
            query: (params) => ({
                url: `tasks/${params.taskId}/files`,
                method: 'GET',
                params: params,
            }),
        }),
        getTaskHistory: builder.query({
            query: (params) => {
                return {
                    url: `task-histories/${params.taskHistoryId}`,
                    method: 'GET',
                };
            },
        }),
        getFilesRelatedToTaskComment: builder.query({
            query: (params) => {
                return {
                    url: `task-comments/${params.taskCommentId}/files`,
                    method: 'GET',
                };
            },
        }),
        getTaskDependencies: builder.query({
            query: (params) => {
                return {
                    url: `task-dependencies`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        // マイタスク用のタスク依存関係取得API
        getTaskDependenciesForMyTask: builder.query({
            query: () => {
                return {
                    url: `task-dependencies/my-task`,
                    method: 'GET',
                };
            },
        }),
        insertTaskDependency: builder.mutation({
            query: (params) => ({
                url: 'task-dependencies/insert',
                method: 'POST',
                body: params,
            }),
        }),
        getTaskDependency: builder.query({
            query: (params) => {
                return {
                    url: `task-dependencies/${params.taskDependencyId}`,
                    method: 'GET',
                };
            },
        }),
        deleteTaskDependency: builder.mutation({
            query: (params) => ({
                url: `task-dependencies/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getSuggestionTaskDependencies: builder.query({
            query: (params) => {
                return {
                    url: `task-dependencies/${params.taskId}/suggestion`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        updateTaskDependency: builder.mutation({
            query: (params) => ({
                url: 'task-dependencies/update',
                method: 'POST',
                body: params,
            }),
        }),
        updateTaskParent: builder.mutation({
            query: (params) => ({
                url: 'tasks/update-task-parent',
                method: 'POST',
                body: params,
            }),
        }),
        insertTaskDependencies: builder.mutation({
            query: (params) => ({
                url: 'task-dependencies/bulk-insert',
                method: 'POST',
                body: params,
            }),
        }),
        updateWbsTask: builder.mutation({
            query: (params) => ({
                url: 'tasks/wbs/update',
                method: 'POST',
                body: params,
            }),
        }),
        renumberWbsNumber: builder.mutation({
            query: (params) => ({
                url: 'tasks/wbs/renumber',
                method: 'POST',
                body: params,
            }),
        }),
        getSuggestionParentTasks: builder.query({
            query: (params) => {
                return {
                    url: `tasks/${params.taskId}/parent-suggestion`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getSuggestionChildTasks: builder.query({
            query: (params) => {
                return {
                    url: `tasks/${params.taskId}/child-suggestion`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getSuggestionTasksForWorkTimesRegister: builder.query({
            query: (params) => {
                return {
                    url: `tasks/work-times/task-suggestion`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getTasksForWorkTimesRegister: builder.query({
            query: (params) => {
                return {
                    url: `tasks/my-scheduled-tasks`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        bulkChangeWorkTimes: builder.mutation({
            query: (params) => ({
                url: 'task-works/bulk-change',
                method: 'POST',
                body: params,
            }),
        }),
        getMyActualWorkTimes: builder.query({
            query: (params) => {
                return {
                    url: `task-works/my-actual-work-times`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        updateGanttTask: builder.mutation({
            query: (params) => ({
                url: 'tasks/gantt/update',
                method: `POST`,
                body: params,
            }),
        }),
        insertTaskFile: builder.mutation({
            query: (params) => ({
                url: 'tasks/files/insert',
                method: `POST`,
                body: params,
            }),
        }),
        insertTaskFiles: builder.mutation({
            query: (params) => ({
                url: 'tasks/files/bulk-insert',
                method: `POST`,
                body: params,
            }),
        }),
        getGanttTasks: builder.query({
            query: (params) => {
                return {
                    url: `tasks/gantt-tasks`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        updateKanbanTask: builder.mutation({
            query: (params) => ({
                url: 'tasks/kanban/update',
                method: 'POST',
                body: params,
            }),
        }),
        verifyBulkInsertTasks: builder.mutation({
            query: (params) => {
                // リクエストをformDataに格納して送信
                const formData = new FormData();
                formData.append('file', params.file);
                formData.append('entityType', params.entityType);
                formData.append('entityRecordId', params.entityRecordId);
                return {
                    url: 'tasks/bulk-insert/verify',
                    method: 'POST',
                    body: formData,
                };
            },
        }),
        bulkInsertTasks: builder.mutation({
            query: (params) => ({
                url: 'tasks/bulk-insert',
                method: 'POST',
                body: params,
            }),
        }),
        // タスクテンプレートからタスク一括登録API
        insertTasksFromTemplate: builder.mutation({
            query: (params) => ({
                url: 'tasks/insert-from-template',
                method: 'POST',
                body: params,
            }),
        }),
        // ガントチャート表示用マイタスク一覧取得API
        getMyTasksForGantt: builder.query({
            query: () => {
                return {
                    url: `tasks/my-tasks-for-gantt`,
                    method: 'GET',
                };
            },
        }),
        getMaxTasksDepthLimit: builder.query({
            query: () => {
                return {
                    url: `tasks/max-tasks-depth-limit`,
                    method: 'GET',
                };
            },
        }),
    }),
    overrideExisting: false,
});
export const { useDeleteTaskMutation, useInsertTaskMutation, useGetTaskKindsQuery, useLazyGetTaskKindsQuery, useInsertTaskKindMutation, useUpdateTaskKindMutation, useReorderTaskKindMutation, useGetTaskKindQuery, useLazyGetTaskKindQuery, useDeleteTaskKindMutation, useReorderTaskCategoryMutation, useInsertTaskStateMutation, useGetTaskStatesQuery, useLazyGetTaskStatesQuery, useGetTaskStateQuery, useLazyGetTaskStateQuery, useUpdateTaskStateMutation, useDeleteTaskStateMutation, useReorderTaskStateMutation, useLazyGetTaskCategoriesQuery, useLazyGetTaskCategoryQuery, useDeleteTaskCategoryMutation, useUpdateTaskCategoryMutation, useInsertTaskCategoryMutation, useGetTaskQuery, useLazyGetTaskQuery, useGetTaskCommentsAndHistoriesQuery, useLazyGetTaskCommentsAndHistoriesQuery, useGetTasksQuery, useLazyGetTasksQuery, useInsertTaskCommentMutation, useUpdateTaskMutation, useGetTaskWorksQuery, useLazyGetTaskWorksQuery, useInsertTaskWorkMutation, useUpdateTaskWorkMutation, useDeleteTaskWorkMutation, useGetTaskWorkQuery, useLazyGetTaskWorkQuery, useDeleteTaskCommentMutation, useUpdateTaskCommentMutation, useUpdateTaskDurationMutation, useDeleteTaskHistoryMutation, useGetTaskCommentQuery, useLazyGetTaskCommentQuery, useGetMyTasksQuery, useLazyGetMyTasksQuery, useGetTaskFilesQuery, useLazyGetTaskFilesQuery, useGetTaskHistoryQuery, useLazyGetTaskHistoryQuery, useGetFilesRelatedToTaskCommentQuery, useLazyGetFilesRelatedToTaskCommentQuery, useGetTaskDependenciesQuery, useLazyGetTaskDependenciesQuery, useGetTaskDependenciesForMyTaskQuery, useLazyGetTaskDependenciesForMyTaskQuery, useInsertTaskDependencyMutation, useGetTaskDependencyQuery, useLazyGetTaskDependencyQuery, useDeleteTaskDependencyMutation, useGetSuggestionTaskDependenciesQuery, useLazyGetSuggestionTaskDependenciesQuery, useUpdateTaskDependencyMutation, useUpdateTaskParentMutation, useInsertTaskDependenciesMutation, useUpdateWbsTaskMutation, useRenumberWbsNumberMutation, useGetSuggestionParentTasksQuery, useLazyGetSuggestionParentTasksQuery, useGetSuggestionChildTasksQuery, useLazyGetSuggestionChildTasksQuery, useGetSuggestionTasksForWorkTimesRegisterQuery, useLazyGetSuggestionTasksForWorkTimesRegisterQuery, useGetTasksForWorkTimesRegisterQuery, useLazyGetTasksForWorkTimesRegisterQuery, useBulkChangeWorkTimesMutation, useGetMyActualWorkTimesQuery, useLazyGetMyActualWorkTimesQuery, useUpdateGanttTaskMutation, useInsertTaskFileMutation, useInsertTaskFilesMutation, useGetGanttTasksQuery, useLazyGetGanttTasksQuery, useUpdateKanbanTaskMutation, useVerifyBulkInsertTasksMutation, useBulkInsertTasksMutation, useInsertTasksFromTemplateMutation, useGetMyTasksForGanttQuery, useLazyGetMyTasksForGanttQuery, useGetMaxTasksDepthLimitQuery, useLazyGetMaxTasksDepthLimitQuery, } = taskApis;
